/* 4Smoke redesign — comportamentos pequenos e seguros. */
(function(){
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents){
    try { if (window.Shopify && typeof Shopify.showPrice === 'function') return Shopify.showPrice(cents); } catch(e){}
    return (cents/100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---- WhatsApp: dica curta uma vez por sessao ---- */
  function waHint(){
    var wa = document.getElementById('s4-wa');
    if(!wa) return;
    var seen = false;
    try { seen = sessionStorage.getItem('s4WaHint') === '1'; } catch(e){}
    if(seen) return;
    setTimeout(function(){
      wa.classList.add('is-hint');
      try { sessionStorage.setItem('s4WaHint','1'); } catch(e){}
      setTimeout(function(){ wa.classList.remove('is-hint'); }, 6000);
    }, 4000);
  }

  /* ---- Pagamentos e garantias por baixo do botao Finalizar compra ---- */
  function addCartTrust(){
    var tpl = document.getElementById('s4-cart-trust-tpl');
    if(!tpl) return;
    document.querySelectorAll('.cart__ctas').forEach(function(ctas){
      var next = ctas.nextElementSibling;
      if(next && next.classList.contains('s4-cart-trust')) return;
      ctas.insertAdjacentElement('afterend', tpl.content.firstElementChild.cloneNode(true));
    });
  }

  /* ---- Progresso do envio gratis (pagina de produto) ---- */
  function updateFsp(total){
    var th = (window.S4 && S4.freeShippingThreshold) || 3000;
    document.querySelectorAll('[data-s4-fsp]').forEach(function(el){
      var txt = el.querySelector('[data-s4-fsp-text]');
      var bar = el.querySelector('[data-s4-fsp-bar]');
      var pct = Math.max(0, Math.min(100, Math.round(total * 100 / th)));
      if(bar) bar.style.width = pct + '%';
      if(!txt) return;
      if(total >= th){ txt.innerHTML = 'Tens <b>envio grátis</b> nesta encomenda'; }
      else if(total > 0){ txt.innerHTML = 'Faltam <b>' + money(th - total) + '</b> para o envio grátis'; }
      else { txt.innerHTML = 'Envio grátis a partir de <b>' + money(th) + '</b>'; }
    });
  }

  /* ---- Sugestao do carrinho (secao s4-cart-extras) ---- */
  var pending = false;
  function refreshCart(){
    if(pending) return;
    pending = true;
    fetch(root + '?sections=s4-cart-extras')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var html = data && data['s4-cart-extras'];
        if(typeof html === 'string'){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-s4-cx]');
          var markup = fresh ? fresh.innerHTML : '';
          document.querySelectorAll('[data-s4-cx]').forEach(function(el){ el.innerHTML = markup; });
        }
      })
      .catch(function(){})
      .then(function(){
        return fetch(root + 'cart.js').then(function(r){ return r.json(); }).then(function(c){ updateFsp(c.total_price || 0); }).catch(function(){});
      })
      .then(function(){ pending = false; addCartTrust(); });
  }

  /* ---- Botao Juntar da sugestao: adiciona sem sair do carrinho ---- */
  function onAddSubmit(e){
    var form = e.target;
    if(!form || !form.matches || !form.matches('form[data-s4-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    if(btn){ btn.disabled = true; btn.setAttribute('aria-busy','true'); }
    var id = form.querySelector('[name=id]');
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    if(drawer && typeof drawer.getSectionsToRender === 'function'){
      sections = drawer.getSectionsToRender().map(function(s){ return s.id; });
    }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id && id.value), quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname })
    })
      .then(function(r){ return r.json(); })
      .then(function(res){
        if(res && res.status){ throw new Error(res.description || 'erro'); }
        if(drawer && typeof drawer.renderContents === 'function' && res && res.sections){
          drawer.renderContents(res);
          document.dispatchEvent(new CustomEvent('afterCartChanged', { bubbles: true }));
        } else {
          window.location.reload();
        }
      })
      .catch(function(){ form.submit(); });
  }

  function init(){
    waHint();
    addCartTrust();
    var drawer = document.querySelector('cart-drawer');
    if(drawer && 'MutationObserver' in window){
      var t;
      new MutationObserver(function(){ clearTimeout(t); t = setTimeout(addCartTrust, 60); }).observe(drawer, {childList:true, subtree:true});
    }
    document.addEventListener('submit', onAddSubmit, true);
    document.addEventListener('afterCartChanged', refreshCart);
    document.addEventListener('afterUpdateQuantity', refreshCart);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
